import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CostUnitService } from '../services/cost-unit.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-cost-unit-handler',
  standalone: true,
  // Reine Weiterleitungs-Route (Einstieg aus Printmaterial). Sie rendert nichts
  // Sichtbares, war fuer Screenreader damit aber eine voellig stumme Seite —
  // und bleibt es, wenn processCostUnit scheitert. Ein visuell verstecktes
  // h1 + Live-Region gibt der Seite einen wahrnehmbaren Zustand (WCAG 1.3.1).
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <h1 class="sr-only" i18n="@@seo.costUnit.title">Kostenstelle</h1>
    <p class="sr-only" role="status" aria-live="polite" i18n="@@costUnit.redirecting">
      Sie werden weitergeleitet.
    </p>
  `,
})
export class CostUnitHandlerComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private costUnitService = inject(CostUnitService);
  private userService = inject(UserService);
  private router = inject(Router);

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const costUnit = params['kostenstelle'];
      if (costUnit) {
        const isLoggedIn = this.userService.isLoggedIn();
        void this.costUnitService.processCostUnit(costUnit).then((success) => {
          if (success) {
            const target = isLoggedIn ? 'registration' : '/auth/register';
            void this.router.navigateByUrl(target);
          }
          // If not successful, component stays empty and Angular routing handles it (404)
        });
      }
    });
  }
}
